import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-doc',
  templateUrl: './help-doc.component.html',
  styleUrls: ['./help-doc.component.css']
})
export class HelpDocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
